var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWaxp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F78E1E",
    d: "m20.271 10.286l-.986.844l1.007.87l1.993-1.714zM14.142 9l3.815 3.407l-1.457.879l-2.572-3h-1.714l-4.5 5.571h1.714l3.643-4.286l1.14 1.286h-1.354l-.857.857h2.854l.788.857h1.715l1.714-1.285l1.5 1.285h1.714L15.857 9zm-5.571 1.286l-.857 2.571l-.857-2.571H5.142l-.857 2.571l-.857-2.571H1.714l1.714 4.285h1.714L6 12l.857 2.571H8.57l1.714-4.285z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaxp);
export default __webpack_public_path__ + "static/media/waxp.89716619122cb49e813488955450f23d.svg";
export { ForwardRef as ReactComponent };